<template>
  <div class="contents shinsei">
    <h2>申請　詳細</h2>

    <div class="container">
      <div class="container-info">
        <div class="container-base">
          <div class="maininfo">
            <component :is="shinseiTypeStr" :id="shinseiId"/>
          </div>

          <div>
            <h3>申請経路</h3>
            <p>この申請は承認不要の申請のため承認経路はありません</p>
          </div>
          <!-- /maininfo -->
        </div>
      </div>
    </div>

    <div class="button-container">
      <p class="prev-page">
        <a @click="router.go(-1)">戻る
        </a>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { RouterConst } from "@/const/Router";
import { useRoute, useRouter } from "vue-router";
import HayabanOsoban from "./parts/HayabanOsoban.vue";
import Koukyuu from "./parts/Koukyuu.vue";
import OptionConst from "@/const/Option";

export default defineComponent({
  setup() {
    // 初期化
    const router = useRouter()
    const route = useRoute()
    const shinseiTypeStr = route.params.type ? route.params.type as string : ""
    const shinseiId = route.params.id ? parseInt(route.params.id as string, 10) : null    
    return {
      RouterConst,
      router,
      shinseiTypeStr,
      shinseiId,
      OptionConst
    };
  },
  // 下のコンポーネント名はOptionConst.SHINSEI_TYPE_NO_APPROVAL.～と合わせること
  components: {
    'hayaban_osoban' :HayabanOsoban,
    'koukyuu' :Koukyuu,
  },
});
</script>

<style lang="scss" scoped>
@import '@scss/components/shinsei-detail.scss';
</style>
